import { ExportStatus } from "../../main/constants/export.constants";

export default class TagShowCtrl {
    constructor($window, $rootScope, $timeout, $stateParams, $state, $filter, SweetAlert, SideMenu, Tag, Events, CurrentAccount) {
        SideMenu.setActive('tag');

        this._stateParams = $stateParams;
        this._filter = $filter;
        this._state = $state;
        this._window = $window;
        this._timeout = $timeout;
        this._rootScope = $rootScope;
        this._translator = $filter('translate');

        this.tagRepo = Tag;
        this.eventHandler = Events;
        this.sweetAlert = SweetAlert;
        this.currentAccount = CurrentAccount;

        this.isShared = this._stateParams.type == 'shared';
        this.showShareOverlay = false;
        this.showInfo = true;
        this.originalName = '';
        this.subscriberCount = '';
        this.repositoryAttributes = { tagId: this._stateParams.id };

        this.tagRepo.find(this._stateParams.id, this.isShared).then((tag) => {
            this.tag = tag.data;
            this.originalName = angular.copy(this.tag.name);
            this.subscriberCount = tag.count_subscribers;
        });

        // Check whether an export is running or has been finished.
        this._timeout(() => {
            this.tagRepo.getExportById(this._stateParams.exportId).then((progress) => {
                if (Array.isArray(progress.data)) {
                    progress.data.forEach((progress) => {
                        this.exportProgressHandler(progress?.status?.value);
                    });
                } else {
                    this.exportProgressHandler(progress.data?.status?.value);
                }
            }).catch((error) => {
                console.error(error);
                this.exportActive = false;
                this.eventHandler.flashEvent('error', this._translator('NOTIFICATION:TYPE:EXPORT_FAILED_HEADER'));
            });
        }, 2000);

        this._rootScope.$on('tag:export:completed', (event, url) => {
            this.exportActive = false;
            this.exportFileUrl = url;
        });

        this._rootScope.$on('account:changed', () => {
            this._state.go('tag.index');
        });
    }

    exportProgressHandler(statusValue) {
        if (statusValue === ExportStatus.Finished) {
            if (this._stateParams.isFileExport) {
                this.tagRepo.getExportDownloadLink(this._stateParams.exportId).then((download) => {
                    this.exportFileUrl = download.data.url;
                });
            }
            this.exportActive = false;
        } else {
            this.exportActive = true;
            this._rootScope.$emit('progress:start', 'tag-export');
        }
    }

    shareTag() {
        this.showShareOverlay = true;
    };

    toggleInfo() {
        this.showInfo = ! this.showInfo;
    };

    updateTag() {
        if (! this.tag.name.length) {
            this.tag.name = this.originalName;
            return this.eventHandler.flashEvent('error', this._filter('translate')('TAG:FLASH:EMPTY_NAME'))
        }

        this.tagRepo.update(this.tag).then(() => {
            this.originalName = this.tag.name;
            this.eventHandler.flashEvent('notification', this._filter('translate')('TAG:FLASH:UPDATE_EXPLAINED'));
        }, (results) => {
            if (results.error = 'DuplicateTag') {
                this.sweetAlert.swal({
                    title: this._filter('translate')('TAG:FLASH:UPDATE_DUPLICATE'),
                    text: this._filter('translate')('TAG:FLASH:UPDATE_DUPLICATE_EXPLAINED').replace(/:name/,  this.tag.name),
                    type: 'error'
                });
            } else if (results.error == 'UnauthorizedError') {
                this.sweetAlert.swal({
                    title: this._filter('translate')('TAG:FLASH:UPDATE_SHARED'),
                    text: this._filter('translate')('TAG:FLASH:UPDATE_SHARED_EXPLAINED'),
                    type: 'error'
                });
            } else {
                this.sweetAlert.swal(this._filter('translate')('TAG:FLASH:CREATE_ERROR'), '', 'error');
            }
        })
    };

    deleteTag() {
        if (this.exportActive) {
            return this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: this._filter('translate')('TAG:SHOW:DELETE_DURING_EXPORT_EXPLAINED'),
                type: 'error'
            });
        }

        var text = this._filter('translate')(this.tag.automations ? 'TAG:SHOW:DELETE_WITH_AUTOMATION' : 'TAG_MODAL:DELETE:DELETE');

        if (this.tag.segments) {
            text += ' ' + this._filter('translate')('TAG:SHOW:DELETE_WITH_SEGMENTS') +
                '\n' + this.tag.segments.data.map((segment) => segment.name).join('\n');
        }

        this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:DELETE'),
                text: text,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this._filter('translate')('GLOBAL:YES'),
                cancelButtonText: this._filter('translate')('GLOBAL:NO')
            }, (isConfirm) => {
                if (isConfirm) {
                    this.tagRepo.delete(this._stateParams.id).then(() => {
                        this._state.go('tag.index');
                        this.eventHandler.flashEvent('notification', this._filter('translate')('TAG:FLASH:DELETED_EXPLAINED'));
                    }, (message) => {
                        let errorText = message.status === 409 ? this._filter('translate')('TAG:FLASH:DELETE_SIGNUP_FORM_ATTACHED_ERROR')
                                .replace(
                                    /:signup-forms/,
                                    message.data.data
                                        .map(item => item.label ? item.label : '[No name]')
                                        .join("\n")
                                ) :
                            this._filter('translate')('GLOBAL:FLASH:DELETE_ERROR');

                        this.sweetAlert.swal({
                            title: this._filter('translate')('TAG:FLASH:DELETE_ERROR'),
                            text: errorText,
                            type: 'error'
                        });
                    });
                }
            }
        )
    };

    toImport() {
        this._state.go('subscriber.import', { tagId: this._stateParams.id });
    };

    toExport() {
        this._state.go('tag.export', { id: this._stateParams.id });
    };

    downloadExport() {
        this._window.open(this.exportFileUrl);
    };
};
